import React, {useState, useEffect} from 'react';
import { useWeb3 } from '@openzeppelin/network/react';

import { Web3ReactProvider } from '@web3-react/core'
import { Web3Provider } from '@ethersproject/providers'
import { useWeb3React } from '@web3-react/core'
import { InjectedConnector } from '@web3-react/injected-connector'

import {formatEther} from "@ethersproject/units";

import { Contract } from '@ethersproject/contracts'
import { isAddress } from '@ethersproject/address'

import useSWR from 'swr'

import GFCABI from '../abi/GameForCrypto.abi.json'

import { fetcher } from '../util/Fetcher.js';

import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

export const Balance = (props) => {
  const { account, library } = useWeb3React()
  const { data: balance, mutate } = useSWR(['getBalance', account, 'latest'], {
    fetcher: fetcher(library),
  })

  useEffect(() => {
    // listen for changes on an Ethereum address
    console.log(`listening for blocks...`)
    library.on('block', () => {
      console.log('update balance...')
      mutate(undefined, true)
    })
    // remove listener when the component is unmounted
    return () => {
      library.removeAllListeners('block')
    }
    // trigger the effect only on component mount
  }, [])

  if (!balance) {
    return <div>...</div>
  }
  return (
  <Paper elevation={3}>
  <div>Ξ {parseFloat(formatEther(balance)).toPrecision(4)}</div>
  </Paper> )
}